import styled from "styled-components";
export const Container = styled.div`
  width: 1200px;
  margin: 0 auto;
  padding: 0 50px;
  @media screen and (max-width: 480px) {
    margin: 0;
    padding: 0;
    width: 100%;
  }
`;
export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const Dot = styled.div`
  text-align: center;
  margin: 0 5px;
`;
export const Main = styled.div`
  width: 70%;
  @media screen and (max-width: 480px) {
    width: 100%;
  }
`;
export const Title = styled.p`
  font-size: 40px;
  margin-bottom: 5px;
  @media screen and (max-width: 480px) {
    font-size: 20px;
    margin-top: 12px;
  }
`;
export const Category = styled.p``;
export const Group = styled.div`
  display: flex;
  color: #767070;
  font-size: 14px;
  margin-bottom: 10px;
  @media screen and (max-width: 480px) {
    font-size: 11px;
  }
`;
export const Date = styled.p``;
export const Read = styled.p``;
export const Cover = styled.img`
  width: 100%;
  height: 300px;
  object-fit: cover;
  @media screen and (max-width: 480px) {
    font-size: 11px;
    height: 150px;
  }
`;
export const Content = styled.div`
  display: block;
`;
